export default {
  namespaced: true,
  state     : {
    employee_study_courses_verification: {
      content: {
        search    : '',
        pagination: {
          rowsPerPage: 10,
        },
        body   : [],
        headers: [],
      },
    },
    showed_courses_verification_filter: false,
  },
  getters: {
    showed_courses_verification_filter : ({showed_courses_verification_filter}) => showed_courses_verification_filter,
    employee_study_courses_verification: ({employee_study_courses_verification}) => employee_study_courses_verification,
  },
  mutations: {
    TOGGLE_COURSES_VERIFICATION_FILTER(state) {
      state.showed_courses_verification_filter = !state.showed_courses_verification_filter;
    },
    SET_COURSES_VERIFICATION_PER_PAGE(state, perPage) {
      const table = state.employee_study_courses_verification.content;
      table.pagination.rowsPerPage = perPage;
    },
    SET_COURSES_VERIFICATION_HEADERS(state, coursesAsHeaders) {
      const table = state.employee_study_courses_verification.content;

      const dynamicHeaders = coursesAsHeaders.map((courseAsHeader) => ({
        text       : courseAsHeader.name,
        value      : courseAsHeader.id,
        sort       : true,
        inner_items: [
          {text: 'Результат', value: 'completionPercent', sort: true},
          {text: 'Период назначения', value: 'appointmentPeriod', sort: true},
        ],
      }));
      table.headers = [
        {text: 'ФИО', value: 'userFio', sort: true},
        {text: 'Организация', value: 'companyName', sort: true},
        ...dynamicHeaders,
      ];
    },
    CHANGE_COURSES_VERIFICATION_SORT(state, column) {
      let table = state.employee_study_courses_verification.content;

      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SET_COURSES_VERIFICATION: (state, coursesSummary) => {
      state.employee_study_courses_verification.content.body = coursesSummary.data
          .map((courseSummary) => {
            // Если нет курсов, вернуть запись как есть
            if (!courseSummary.courses) return courseSummary;

            // Фильтруем курсы, оставляя только те, у которых isComplete === false
            const filteredCourses = courseSummary.courses.filter((course) => !course.isComplete);

            // Если после фильтрации курсов нет, возвращаем null
            if (filteredCourses.length === 0) return null;

            // Обрабатываем и возвращаем структуру с оставшимися курсами
            return {
              ...courseSummary,
              courses: filteredCourses, // Обновляем список курсов
              ...filteredCourses.reduce((acc, course) => ({
                ...acc,
                [course.id]: course,
              }), {}),
            };
          })
          .filter((item) => item !== null); // Убираем записи без оставшихся курсов
    },
    SET_COURSES_VERIFICATION_PAGINATION(state, value) {
      const table = state.employee_study_courses_verification.content;
      table.pagination = {
        ...table.pagination,
        ...value,
      };
    },
    SET_COURSES_VERIFICATION_PAGE(state, value) {
      const table = state.employee_study_courses_verification.content;
      table.pagination.page = value;
    },
  },
  actions: {
    async change_courses_verification_per_page({commit}, event) {
      commit('SET_COURSES_VERIFICATION_PER_PAGE', event);
      commit('SET_COURSES_VERIFICATION_PAGE', 1);
    },
  },
};
